import React from 'react'
import _ from 'lodash'
import { formatPercentage0, middleOfThree } from '../../utils'

export default ({
    numerator,
    denominator,
    nullText = 'N/A',
    formatNumber = (n) => Math.round(n),
    ...props
}) => {
    let value, text
    numerator = numerator ? Math.round(numerator * 10) / 10 : 0
    denominator = denominator ? Math.round(denominator * 10) / 10 : 0
    if (numerator == null) {
        value = NaN
        text = nullText
    } else if (denominator == null || denominator === 0) {
        value = NaN
        text = `${formatNumber(numerator)} / -`
    } else {
        value = numerator / denominator
        text = `${formatNumber(numerator)} / ${formatNumber(
            denominator
        )} (${formatPercentage0((numerator / denominator) * 100)})`
    }

    return <ProgressBar value={value} text={text} {...props} />
}
const ProgressBar = ({
    width,
    height,
    value,
    text,
    className,
    radius = 0,
    ...props
}) => {
    var val = !isNaN(value) ? value : 0
    var color
    if (val < 0.8) {
        color = '#FFC734'
    } else if (val <= 1.0) {
        color = '#ffb534'
    } else {
        color = '#f05a28'
    }
    var innerWidth = middleOfThree(0, val, 1) * 100 + '%'

    return (
        <svg
            className={className}
            style={{
                width: width,
                height: height,
                display: 'inline-block',
            }}
        >
            <g shapeRendering="crisp-edges">
                <rect
                    x={0}
                    y={0}
                    width="100%"
                    height="100%"
                    fill={!isNaN(value) ? '#888' : '#aaa'}
                    stroke="none"
                    rx={radius}
                    ry={radius}
                />
                {value > 0 ? (
                    <g>
                        <rect
                            x={0}
                            y={0}
                            width={innerWidth}
                            height="100%"
                            fill={color}
                            stroke="none"
                            rx={radius}
                            ry={radius}
                        />
                    </g>
                ) : null}
                {text ? (
                    <text
                        x="50%"
                        y="50%"
                        fill="white"
                        textAnchor="middle"
                        dy="0.4em"
                        style={{
                            fontWeight: 600,
                            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.43)',
                        }}
                    >
                        {text}
                    </text>
                ) : null}
            </g>
        </svg>
    )
}
